
import { DexAssessmentController } from "@/app/ui/controllers/DexAssessmentController";
import { prop, Vue } from "vue-class-component";
import { ApiRequestList } from "@/domain/entities/MainApp";
import { ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";
import formatDateNumber from "@/app/infrastructures/misc/common-library/FormatDateNumber";
import parsingErrorResponse from "@/app/infrastructures/misc/common-library/ParsingErrorResponse";
import { SummaryBacklog } from "@/domain/entities/DexAssessment";

class Props {
  groupBy = prop<string>({
    type: String,
    default: "l1_l2"
  });
}

export default class SummaryByReason extends Vue.with(Props) {
  dashboardData: ResponsePayloadV2 = new ResponsePayloadV2();
  async fetchData() {
    const {
      startDate,
      endDate,
      reasonCode,
      city,
      courierPhone
    } = DexAssessmentController.filter;

    try {
      this.dashboardData.loading = true;
      const res = await DexAssessmentController.getSummaryByReason(
        new ApiRequestList({
          startDate: formatDateNumber(startDate),
          endDate: formatDateNumber(endDate),
          groupBy: this.groupBy,
          reasonDex: reasonCode.toString(),
          "3lc": city?.code,
          courierPhone: courierPhone
        })
      );

      const data: SummaryBacklog = res.data;
      const height = data.labels.length * 45;
      this.byReasonChart = {
        ...this.byReasonChart,
        series: data.datasets.map((item: any) => ({
          name: item.label,
          data: item.data
        })),
        categories: data.labels,
        height: height <= 175 ? 175 : height,
        total: data.totalTicket
      };
    } catch (error) {
      this.dashboardData.message = parsingErrorResponse(error).type;
    } finally {
      this.dashboardData.loading = false;
    }
  }

  byReasonChart = {
    series: [] as any[],
    categories: [] as any[],
    height: 0,
    color: ["#58C5E2", "#ECB888", "#7ACB90", "#D4797C"],
    rounded: false,
    barHeight: "50%",
    total: 0
  };

  get total(): string {
    return `${this.byReasonChart.total} ${this.$t(
      "dexAssessmentConsolidator.ticketCount"
    )}`;
  }

  get titleChart() {
    return this.groupBy === "dispute"
      ? this.$t("dexAssessmentDashboard.titleChartByReasonDispute")
      : this.$t("dexAssessmentDashboard.titleChartByReason");
  }
}
